/** @format */

import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useSafeNavigate } from '@/shared/lib/safe-navigate'
import { useAuth } from '@/entities/auth/model'

interface PrivateRouteProps {
  children: React.ReactNode
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { token } = useAuth()
  const navigate = useSafeNavigate()
  const location = useLocation()
  // React 19: Strict Mode uchun ref'lardan foydalanish
  const hasNavigatedRef = useRef(false)
  const prevTokenRef = useRef(token)
  const mountedRef = useRef(false)

  useEffect(() => {
    // React 19: Strict Mode da ikki marta ishlashini oldini olish
    if (!mountedRef.current) {
      mountedRef.current = true
    }

    // Faqat token o'zgarganda yoki token yo'q bo'lganda navigate qilish
    const tokenChanged = prevTokenRef.current !== token

    if (!token && (tokenChanged || !hasNavigatedRef.current)) {
      // Faqat login sahifasi bo'lmaganda navigate qilish
      if (location.pathname !== '/login') {
        hasNavigatedRef.current = true
        navigate('/login', { replace: true })
      }
    } else if (token) {
      // Token bo'lsa, navigate flag'ni reset qilish
      hasNavigatedRef.current = false
    }

    prevTokenRef.current = token

    // React 19: Cleanup function - Strict Mode uchun
    return () => {
      // Cleanup logic if needed
    }
  }, [token, location.pathname, navigate]) // React 19: location.pathname va navigate dependency sifatida qoldirildi

  if (!token) return null // Prevents rendering protected content before redirect

  return <>{children}</>
}

export default PrivateRoute
